
import { httpss } from "../utils/host";
export const getTeamsResult = `${httpss}/apis_v1/result/getListResultByTeam`;
export const getTopResultOfTeam = `${httpss}/apis_v1/result/getTopResultOfTeam`;
export const getTop10Result = `${httpss}/apis_v1/result/getTop10Result`;